<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M8.4 4h7.2v5.4a3.6 3.6 0 0 1-7.2 0Z" />
	<path d="M8.4 5.6H6.1a2.6 2.6 0 0 0 2.5 4" />
	<path d="M15.6 5.6h2.3a2.6 2.6 0 0 1-2.5 4" />
	<path d="M12 13v3" />
	<path d="M9.6 16h4.8v2.8H9.6z" />
	<path d="M7.4 18.8h9.2" />
</svg>
